import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import DynamicTable from "../../components/dynamicTable";
import SelectInput from "../../components/select";
import TextInput from "../../components/textInput";
import TableData from "../../Data/commissions.json";
import { CSVLink } from "react-csv";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = [
  // "VENDOR #ID",
  "CUSTOMER DETAILS",
  "TOTAL SALES",
  "AFFILIATE COMMISSION%",
  "AMOUNT",
  // "ACTION",
];

const displayRows = [
  // "user_id",
  "commission_user",
  "total_commission_amount",
  "total_commission_percenttage",
  "total_commission_sales",
  // "actions",
];

const headersForCsv = [
  { label: "VENDOR NAME", key: "vendorName" },
  { label: "VENDOR EMAIL", key: "vendorEmail" },
  { label: "TOTAL SALES", key: "orderAmount" },
  { label: "COMMISSION%", key: "commissionPercentage" },
  { label: "AMOUNT", key: "commissionAmount" },
  // { label: "CREATED-AT", key: "createdAt" },
];

const AllCommissions = ({ data }) => {
  const [filterByStatus, setFilterByStatus] = useState("All");
  const [searchValue, setSearchValue] = useState("");
  const [filterData, setFilterData] = useState([]);
  console.log(filterData, "filterDatafilterDatafilterData");

  useEffect(() => {
    filterAllVendor();
  }, [searchValue, data]);

  const filterAllVendor = () => {
    if (!searchValue.trim()) {
      setFilterData(data);
      return;
    }
    const filtered = data.filter(
      (vendor) =>
        vendor?.referrerName
          ?.toLowerCase()
          ?.includes(searchValue.toLowerCase()) ||
        vendor?.referrerEmail
          ?.toLowerCase()
          ?.includes(searchValue.toLowerCase())
    );
    setFilterData(filtered);
  };

  return (
    <AppContainer>
      <Stack
        px={3}
        py={2}
        gap={2}
        direction={{ md: "row" }}
        alignItems={"center"}
      >
        <TextInput
          sx={{ flex: 1 }}
          placeholder={"Search Vendors"}
          InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Stack
          direction={{ sm: "row" }}
          width={"100%"}
          flex={2}
          gap={2}
          justifyContent={{ md: "flex-end" }}
        >
          <CSVLink
            data={data}
            headers={headersForCsv}
            filename="filtered-users.csv"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Box
              height={40}
              bgcolor={"#003B95"}
              borderRadius={2}
              sx={{ width: { xs: "100%", md: 120 } }}
            >
              <Button>
                <Typography color="#FFF">Export</Typography>
              </Button>
            </Box>
          </CSVLink>
        </Stack>
      </Stack>
      <Divider />
      {filterData.length > 0 ? (
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={filterData}
          showPagination={true}
          showCommissionMenu={true}
        />
      ) : (
        <Typography
          color="black"
          fontSize={14}
          fontWeight={700}
          textAlign="center"
          padding="30px 0"
        >
          No Commission Found!
        </Typography>
      )}
    </AppContainer>
  );
};

export default AllCommissions;
